document.addEventListener('DOMContentLoaded', function () {
 
  function scienceLinks() {
    console.log('science links') 

    //get url params string
    const urlParams = window.location.search.substring(1);
    

    console.log(urlParams)

    if(urlParams == "longevity") { 

      //scroll to .info-tab-wrap
      const yOffset = -0; // Negative value to scroll higher
      const y = document.querySelector('.info-tab-wrap').getBoundingClientRect().top + window.scrollY + yOffset;
      document.querySelector('.info-tab-wrap').classList.add('active'); 
      document.querySelector('.info-tab-wrap .button').innerHTML = 'Read Less';
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    if(urlParams == "nootropics") { 

      //scroll to .info-tab-wrap
      const yOffset = -0; // Negative value to scroll higher
      const y = document.querySelectorAll('.info-tab-wrap')[1].getBoundingClientRect().top + window.scrollY + yOffset;
      document.querySelectorAll('.info-tab-wrap')[1].classList.add('active'); 
      document.querySelectorAll('.info-tab-wrap')[1].querySelector('.button').innerHTML = 'Read Less';
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

  }

  function handleBlogPagination() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const pageParam = urlSearchParams.get('page');
    
    // Check if we're on a blog page with pagination (any page parameter)
    if (pageParam) {
      const blogPostsElement = document.getElementById('blog-posts');
      
      if (blogPostsElement) {
        // Add a small delay to ensure the page is fully loaded
        setTimeout(() => {
          const yOffset = -50; // Adjust this value to control the scroll position offset
          const y = blogPostsElement.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 100);
      } else {
        // Fallback: try to find blog posts container with different selector
        const fallbackElement = document.querySelector('[id*="blog-posts"]');
        if (fallbackElement) {
          setTimeout(() => {
            const yOffset = -50;
            const y = fallbackElement.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }, 100);
        }
      }
    }
  }
 
  // === Global initialisation ===
scienceLinks();
handleBlogPagination();
initializeSwipers();
initCountUp();
animatePaths();
graphToggle();
expandable();
unmute();
bundles();
faqTab();
initMobileBlogPosts();
 
  // Function to initialize Swiper
  function initializeSwiper(section) { 
    const slidesMobile = parseFloat(section.getAttribute('data-slides-mobile'), 10) || 2;
    const slidesDesktop = parseFloat(section.getAttribute('data-slides-desktop'), 10) || 4;
    const spaceBetweenMobile = parseFloat(section.getAttribute('data-space-between-mobile'), 10) || 2;
    const spaceBetweenDesktop = parseFloat(section.getAttribute('data-space-between-desktop'), 10) || 2;
    const loop = section.getAttribute('data-loop') === 'true' || false;

    const experts = section.getAttribute('data-experts') === 'true';
    const autoplay = section.getAttribute('data-auto-scroll') === 'true';
    const expandable = section.getAttribute('data-expandable') === 'true';



    const nextBtn = section.querySelector('.swiper-button-next'); 
    const prevBtn = section.querySelector('.swiper-button-prev');



    const swiperInstance = new Swiper(section, {
        autoHeight: false,
        slidesPerView: slidesDesktop,
        spaceBetween: spaceBetweenDesktop,
        // simulateTouch: true,
        mousewheel: {
            forceToAxis: true, // Swipes only in the axis of movement
            sensitivity: 1, // Adjust for finer or coarser control
        },
        // slidesOffsetAfter: 330.665,
        autoplay: autoplay ? { 
            delay: 50, // Continuous scrolling (no delay between slides)

            // pauseOnMouseEnter: true
        } : false,
        speed: autoplay ? 4650 : 500, // Adjust scrolling speed for smoothness
        // freeMode: true, // Enable free mode for smooth scrolling
        loop: loop ? true : false, // Enable loop mode
        breakpoints: {
            320: {
                slidesPerView: slidesMobile,
                spaceBetween: spaceBetweenMobile,
            },
            1040: {
                slidesPerView: slidesDesktop,
                spaceBetween: spaceBetweenDesktop,
            }
        },
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        pagination: {
            el: section.querySelector('.swiper-pagination'),
            type: 'progressbar', // Enables the progress bar
        },
    });



    

    if (autoplay) {
      let paused = false; // Track whether autoplay is paused manually
      let currentTranslate = 0; // Store the exact current position
    
      section.addEventListener('mouseenter', () => {
        if (paused) return; // Prevent multiple triggers
        paused = true;
    
        // Get the real-time transform value
        const matrix = window.getComputedStyle(swiperInstance.wrapperEl).transform;
        currentTranslate = matrix !== 'none' ? parseFloat(matrix.split(',')[4]) : 0;
    
        swiperInstance.autoplay.stop(); // Stop autoplay
        swiperInstance.wrapperEl.style.transition = 'none'; // Disable ongoing transitions
        swiperInstance.setTranslate(currentTranslate); // Freeze slider at exact position
    

      });
    
      section.addEventListener('mouseleave', () => {
        if (!paused) return; // Prevent multiple triggers
        paused = false;

        setTimeout(() => {
          swiperInstance.autoplay.start(); // Ensure autoplay restarts

        }, 150);
      });
    }

    if (expandable) {
  setTimeout(setexpandables, 0);
}

    // Event Listener for slide change

    if(experts) {
      const cards = document.querySelectorAll('.experts__media');
      const inner = document.querySelector('.expandable__inner');
  
      cards.forEach((btn, i) => {
        const video = btn.querySelector('video');
        if(i != 0){

          if(video) {
    
            setTimeout(() => {
              video.pause();
            }, 5000);      
    
            //remove autoplay
    
          }
        }
      });


      swiperInstance.on('slideChange', () => {

        cards.forEach((btn) => {
          const video = btn.querySelector('video');      
    

          if(video) {           
            video.pause();   
          }
        });

    
        const activeIndex = swiperInstance.activeIndex; // Get the active slide index
        const realIndex = swiperInstance.realIndex; // Get the real index (ignoring duplicated slides in a loop)

        // Perform action on the active slide

        setTimeout(() => {
          const activeSlide = section.querySelector('.swiper-slide-active');  
          const video = activeSlide.querySelector('.slider-item-media-element');  
  
          if(video) {

            video.play();
          }
        }, 100);  


 
        // activeSlide.style.backgroundColor = 'lightblue'; // Example: Change background color
      });
    }
    

    return swiperInstance;
  }

  function setexpandables() {

    //if window width above 1200
    if(window.innerWidth > 1200) {


    setTimeout(() => {

      const cards = document.querySelectorAll('.expandable__inner .expandable__card');

      //get window width
      const windowWidth = window.innerWidth;

      console.log(cards[1])

      let standardWidth = 0

      if(cards[1].classList.contains('active')) {
        standardWidth = parseFloat(window.getComputedStyle(cards[0]).width);
      }else{
        standardWidth = parseFloat(window.getComputedStyle(cards[1]).width);
      }


      
      const expandedWidth = standardWidth * 2;
      const paddingTop = standardWidth;

      console.log(standardWidth, "standardWidth");
      console.log(expandedWidth, "expandedWidth");
      
      // Ensure CSS variable is correctly set with 'px'
      document.documentElement.style.setProperty('--expanded-width', `${expandedWidth - 10}px`);
      document.documentElement.style.setProperty('--padding-top', `${paddingTop}px`);

      cards.forEach((btn, i) => {
        console.log(btn.style.width);
      })
      
    }, 750);
  }

  }


function initializeSwipers() {
  const sections = document.querySelectorAll('.swiper-container');

  sections.forEach(section => {
    // Destroy existing Swiper safely
    if (section.swiper) {
      section.swiper.destroy(true, true);
    }

    // Initialise fresh
    initializeSwiper(section);

    section.style.opacity = 1;
  });
}

  // Helper function to animate the count-up
  function countUp(element, target) {
    let start = 0;
    const duration = 2000; 
    const steps = 100;
    const stepTime = duration / steps;
    const increment = target / steps;

    const hasDecimals = target % 1 !== 0;
    const decimalPlaces = hasDecimals ? 2 : 0;

    element.style.overflow = "visible";
    element.style.width = "auto";

    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target; // cap to avoid rounding overshoot
        clearInterval(interval);
      }
      element.textContent = start.toFixed(decimalPlaces);
    }, stepTime);
  }

  // Function to lock the width of the elements
  function lockWidth(element) {
    const computedStyle = window.getComputedStyle(element);
    const width = computedStyle.width;
    element.style.width = width; // Set the width explicitly
    element.style.overflow = "hidden"; // Ensure no overflow during animation
  }

  // Function to observe elements and trigger the animation
  function initCountUp() {
    const elements = document.querySelectorAll('.js-count-up');

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target;
            const targetNumber = parseFloat(element.textContent);

            element.style.overflow = "visible";
            countUp(element, targetNumber);

            observer.unobserve(element); // Stop observing once the animation runs
          }
        });
      },
      {
        threshold: 0.5 // Trigger when 50% of the element is visible
      }
    );

    elements.forEach((element) => {
      observer.observe(element);
    });
  }

  function animatePaths() {
    const paths = document.querySelectorAll(".draw");
  
    paths.forEach((path) => {
      const pathLength = path.getTotalLength(); // Get the length of the path
      path.style.strokeDasharray = pathLength; // Set dasharray to the path length
      path.style.strokeDashoffset = pathLength; // Initially hide the path
      path.classList.add("animate"); // Add the class to prepare for animation
  
      // Intersection Observer to animate only when the path is in view
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            console.log(entry)
            if (entry.isIntersecting) {
              path.classList.add("active"); // Trigger the animation
              observer.unobserve(path); // Stop observing once animated
            }
          });
        },
        { threshold: 0.1 } // Trigger when 10% of the path is visible
      );
  
      observer.observe(path);
    });
  }

  function graphToggle() {
    const toggleBtns = document.querySelectorAll('.graph__toggle-btn');
    const graphs = document.querySelectorAll('.graph__animation');
    const content = document.querySelectorAll('.graph__content-wrap');
    const images = document.querySelectorAll('.graph-image');  



    toggleBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {

        const blockId = e.target.getAttribute('data-block-id'); 



        toggleBtns.forEach((btn) => {
          btn.classList.remove('active');
        });

        content.forEach((item) => {
          item.classList.remove('active');

          if(item.getAttribute('data-block-id') === blockId) {
            item.classList.add('active');
          }
        });

        graphs.forEach((graph) => {
          graph.classList.remove('active');

          if(graph.getAttribute('data-block-id') === blockId) {
            graph.classList.add('active');
          }
        });

        images.forEach((image) => {
          image.classList.remove('active');

          if(image.getAttribute('data-block-id') === blockId) {
            image.classList.add('active');
          }
        });

       

        btn.classList.toggle('active');


      });
    });

  }

  function bundles(){

    const quickAddBtns = document.querySelectorAll('product-bundler .add-to-cart');

    quickAddBtns.forEach((btn) => {
      btn.click();
    });
  }


  function expandable() {
    const expandableSections = document.querySelectorAll('.expandable__inner');
  
    if (expandableSections.length === 0) return;
  
    expandableSections.forEach((inner) => {
      const expandableBtns = inner.querySelectorAll('.expandable__card');
      if (expandableBtns.length === 0) return;
  
      let currentIndex = Array.from(expandableBtns).findIndex(btn => btn.classList.contains('active'));
      if (currentIndex === -1) currentIndex = 0; // Default to first card if none active
      let autoRotateInterval;
  
      function setActiveCard(index) {
        expandableBtns.forEach((btn, i) => {
          if (i === index) {
            btn.classList.add('active');
            const video = btn.querySelector('video');
            if (video) video.play();
          } else {
            btn.classList.remove('active');
            const video = btn.querySelector('video');
            if (video) video.pause();
          }
        });
      }
  
      function startAutoRotate() {
        stopAutoRotate(); // Ensure any previous interval is cleared
        autoRotateInterval = setInterval(() => {
          currentIndex = (currentIndex + 1) % expandableBtns.length;
          setActiveCard(currentIndex);
        }, 7000);
      }
  
      function stopAutoRotate() {
        clearInterval(autoRotateInterval);
      }
  
      expandableBtns.forEach((btn, index) => {
        btn.addEventListener('click', function () {
          stopAutoRotate();
          setActiveCard(index);
          currentIndex = (index ) % expandableBtns.length;
          startAutoRotate();
        });
  
        btn.addEventListener('mouseenter', stopAutoRotate);
        btn.addEventListener('mouseleave', startAutoRotate);
      });
  
      startAutoRotate();
    });
  }
  


  function unmute() {

    const muteToggles = document.querySelectorAll('.mute-toggle');

    muteToggles.forEach((btn) => {
      btn.addEventListener('click', (e) => {

        // lok for nereast video up
        const video = btn.parentElement.parentElement.querySelector('video');

        if(video) {
          if(video.muted) {
            video.muted = false;
            btn.parentElement.classList.remove('muted');

          } else {
            video.muted = true;
            btn.parentElement.classList.add('muted');

          }
        }

      });
    });

  }


  console.log('loaded')

  function faqTab() {
    const tabButtons = document.querySelectorAll('.info-tab-wrap .button');

    const tabsT = document.querySelectorAll('.info-tab__right .info-tabs__tab');

    tabsT.forEach(tab => {
      
      tab.addEventListener('click', () => {
        console.log(tab)

          if(tab.classList.contains('active')) {
       
          }
          else {
            // tab.classList.remove('active');

            // tab.querySelector('.info-tabs__tab-caption').style.display = 'none';
            // tab.classList.add('active');
          }
  
  

          console.log('else') 
  
          setTimeout(()=>{
            
            // const yOffset = -200; // Negative value to scroll higher
            // const y = tab.getBoundingClientRect().top + window.scrollY + yOffset;
            
            // window.scrollTo({ top: y, behavior: 'smooth' });    
          }, 150);   
  
      });
    });

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const wrap = btn.closest('.info-tab-wrap');

        if(wrap.classList.contains('active')) {
          wrap.classList.remove('active');
          btn.innerHTML = 'Read More';  
        }
        else {
          wrap.classList.add('active');
          btn.innerHTML = 'Read Less';
        }
      });

    });
  }


  async function waitForElement(selector, root = document, interval = 100, timeout = 5000) {
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
      const checkExist = setInterval(() => {
        const element = root.querySelector(selector);
        if (element) {
          clearInterval(checkExist);
          resolve(element);
        }
        if (Date.now() - startTime > timeout) {
          clearInterval(checkExist);
          reject(new Error("Element not found within timeout."));
        }
      }, interval);
    });
  }
  
  
  
  // Handle browser back/forward navigation
  window.addEventListener('popstate', function() {
    handleBlogPagination();
  });
  
  

  document.querySelectorAll(".info-tabs__tab").forEach(tab => {
    tab.innerHTML = tab.innerHTML.replace(/\[(\d{2})\]/g, '<span class="sup">[$1]</span>');
  });


  //on resize
  window.addEventListener('resize', function() {
    setexpandables()
  });



  


  

  // Shopify Customizer Event Listener for Switching Layouts
  document.addEventListener('shopify:section:load', function() {
    initializeSwipers();
    initCountUp()
    animatePaths()
    graphToggle()
    expandable()
    setexpandables()
    handleBlogPagination()
    

  });

  function initMobileBlogPosts() {
    const blogPosts = document.querySelectorAll('.media-posts .expandable__card');
  
    if (window.innerWidth < 768) {
      blogPosts.forEach(post => {
        let startX, startY;
        let moved = false;
  
        post.addEventListener('touchstart', (e) => {
          const touch = e.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          moved = false;
        });
  
        post.addEventListener('touchmove', (e) => {
          const touch = e.touches[0];
          const deltaX = Math.abs(touch.clientX - startX);
          const deltaY = Math.abs(touch.clientY - startY);
          if (deltaX > 10 || deltaY > 10) {
            moved = true;
          }
        });
  
        post.addEventListener('touchend', (e) => {
          if (!moved) {
            const link = post.querySelector('.js-blog-click');
            if (link) window.location.href = link.href;
          }
        });
  
        // Optional: Add mouse fallback for desktop or testing in browser
        let mouseDownX, mouseDownY;
        post.addEventListener('mousedown', (e) => {
          mouseDownX = e.clientX;
          mouseDownY = e.clientY;
          moved = false;
        });
  
        post.addEventListener('mousemove', (e) => {
          if (Math.abs(e.clientX - mouseDownX) > 5 || Math.abs(e.clientY - mouseDownY) > 5) {
            moved = true;
          }
        });
  
        post.addEventListener('mouseup', (e) => {
          if (!moved) {
            const link = post.querySelector('.js-blog-click');
            if (link) window.location.href = link.href;
          }
        });
      });
    }
  }
  

  document.addEventListener('shopify:block:select', function() {
    initializeSwipers();
    initCountUp()
    animatePaths()
    graphToggle()
    expandable()
    setexpandables()
    initMobileBlogPosts()
    handleBlogPagination()
    
  });


  
});

document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(".bundle-value-line");
  if (!el) return;

  const price = Number(el.dataset.bundlePrice || 0);
  const compare = Number(el.dataset.bundleCompare || 0);
  // Subscription per-delivery price, emitted by main-product.liquid on
  // non-ladder templates only, so this line keeps today's behaviour on
  // quantity upsell pages. With it, the saving tracks the widget selection
  // instead of always quoting the one-time figure.
  const subPrice = Number(el.dataset.bundleSubPrice || 0);

  // One-time sale (snippets/mnp-sale.liquid, Black Friday 2026). While it
  // runs, the One-time option shows the sale price with the normal bundle
  // price struck through (not the individual value, so "Save 20%" adds up
  // and it matches the Google ad; Gabriel, 30 Oct 2026), and the value line
  // counts the sale price. A page cached from
  // before or after the sale falls back to normal prices on the visitor's
  // clock. Checkout charges the matching Shopify automatic discount.
  const salePrice = Number(el.dataset.bundleSalePrice || 0);
  const saleStart = Number(el.dataset.bundleSaleStart || 0);
  const saleEnd = Number(el.dataset.bundleSaleEnd || 0);
  const nowS = Date.now() / 1000;
  const saleOn = salePrice > 0 && salePrice < price && nowS >= saleStart && nowS <= saleEnd;
  const oneTimePaid = saleOn ? salePrice : price;
  const oneTimeStrike = saleOn ? price : compare;
  // Subscription first order during the sale (extra % off the first
  // payment, automatic discount): price and % on the subscription option,
  // and the value line notes the renewal price.
  const subSalePrice = Number(el.dataset.bundleSubSalePrice || 0);
  const subSalePct = Number(el.dataset.bundleSubSalePct || 0);
  const subSaleOn = saleOn && subSalePrice > 0 && subPrice > 0;

  if (!compare && !saleOn) return;

  // The data attributes are already in the visitor's market currency
  // (Liquid prices are presentment prices), so only the symbol is needed.
  // en-US gives "£45.89", "$56.98", "€", "CA$", "A$", symbol first.
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  };

  function renderValueLine() {
    let paid = oneTimePaid;
    let subSelected = false;
    try {
      const form = el.closest('form') || document;
      const planInput = form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
      if (planInput && planInput.value && subPrice) { paid = subSaleOn ? subSalePrice : subPrice; subSelected = true; }
    } catch (e) { /* keep one-time figure */ }
    const renewNote = subSelected && subSaleOn ? ` · Renews at ${formatMoney(subPrice)}` : '';
    if (compare <= paid) { el.textContent = renewNote ? renewNote.replace(' · ', '') : ''; return; }
    // During the sale the saving is measured from the normal bundle price
    // (as the struck prices are), so the line is labelled "Bundle price";
    // outside the sale it is the individual value (Gabriel, 31 Oct 2026).
    const base = saleOn ? price : compare;
    const saved = base - paid;
    el.textContent = `${saleOn ? 'Bundle price' : 'Individual value'}: ${formatMoney(base)} · You save ${formatMoney(saved)} today${renewNote}`;
  }

  // Bundle pages use the standard Recharge widget (open shadow root). Two
  // additions inside it, re-applied whenever the widget re-renders:
  // - the one-time option gets the individual value struck through before
  //   its price, built like the subscription option's own struck price so
  //   the widget's styles and the page's ::part rules apply to it;
  // - "(cancel anytime)" is split into its own part so custom.css can drop
  //   it onto a second line on phones.
  // Only the standard widget has a rc-purchase-option__price part, so the
  // quantity upsell widget on single products is never touched.
  function enhanceWidget(root) {
    try {
      const otPrice = root.querySelector('[part="rc-purchase-option__price"]');
      if (otPrice && oneTimeStrike > oneTimePaid && !root.querySelector('.mnp-onetime-compare')) {
        const strike = document.createElement('span');
        strike.className = 'rc-price strike-through text-muted mnp-onetime-compare';
        strike.setAttribute('part', 'rc-purchase-option__original-price');
        strike.textContent = formatMoney(oneTimeStrike);
        otPrice.parentNode.insertBefore(strike, otPrice);
      }
      if (otPrice && saleOn && otPrice.textContent.trim() !== formatMoney(salePrice)) {
        otPrice.textContent = formatMoney(salePrice);
      }
      // Black Friday look (Gabriel, 28 Oct 2026), laid out like the picker on
      // single products: a "Black Friday Sale" tag on the top edge of both
      // options, above the price (right); the "Save N%" badges beside the
      // option names on desktop and below them on phones, in black pills
      // (Recharge's own top-right Save badge is hidden and replaced, see
      // below); the add to cart button is turned black in main-product.liquid.
      // !important inside the shadow root wins over the page's ::part rules.
      if (otPrice && saleOn && !root.querySelector('#mnp-bf-widget')) {
        const st = document.createElement('style');
        st.id = 'mnp-bf-widget';
        st.textContent = '.rc-purchase-option { position: relative; }'
          + ' .rc-purchase-option::before { content: "Black Friday Sale"; position: absolute; top: -10px; right: 20px; z-index: 1; padding: 0 8px; border-radius: 999px; background: #111; color: #fff; font-size: 12px; line-height: 20px; font-weight: 600; white-space: nowrap; pointer-events: none; }'
          + (subSaleOn ? ' .rc-purchase-option__badge { display: none !important; }' : ' .rc-purchase-option__badge { background: #111 !important; color: #fff !important; }')
          // The selected option's outline and radio dot black too (28 Oct);
          // the radio icon draws in --rc-widget-brand-color.
          + ' .rc-purchase-option[rc-selected] { border-color: #111 !important; }'
          + ' rc-radio-icon { --rc-widget-brand-color: #111; }'
          // "Save N%" badges, styled like the picker's.
          + ' .mnp-ot-label { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 4px 8px; }'
          + ' .mnp-ot-badge, .mnp-sub-badge { display: inline-block; padding: 0 8px; border-radius: 999px; background: #111; color: #fff; font-size: 12px; line-height: 20px; font-weight: 600; white-space: nowrap; vertical-align: middle; }'
          + ' .mnp-sub-badge { margin: 0 6px 0 4px; }'
          + ' @media (max-width: 767px) { .mnp-ot-label { flex-direction: column; align-items: flex-start; } .mnp-sub-badge { display: table; margin: 4px 0; } }';
        root.appendChild(st);
      }
      // One-time option: "Save N%" (the one-time sale %, e.g. 20) next to
      // "One-time Purchase" (28 Oct 2026). The label text and the badge share
      // one wrapper so the badge can drop below the text on phones.
      const otSel = saleOn && root.querySelector('.rc-selection__onetime .rc-purchase-option__selector');
      if (otSel && !otSel.querySelector('.mnp-ot-badge')) {
        const tn = Array.prototype.find.call(otSel.childNodes, function (nd) { return nd.nodeType === 3 && nd.nodeValue.trim(); });
        if (tn) {
          const label = document.createElement('span');
          label.className = 'mnp-ot-label';
          label.appendChild(document.createTextNode(tn.nodeValue.trim()));
          const otBadge = document.createElement('span');
          otBadge.className = 'mnp-ot-badge';
          otBadge.textContent = 'Save ' + Math.round((price - salePrice) * 100 / price) + '%';
          label.appendChild(otBadge);
          otSel.replaceChild(label, tn);
        }
      }
      if (subSaleOn) {
        const subOpt = root.querySelector('.rc-purchase-option__subscription');
        const subPriceEl = subOpt && subOpt.querySelector('[part="rc-purchase-option__discounted-price"]');
        if (subPriceEl && subPriceEl.textContent.trim() !== formatMoney(subSalePrice)) subPriceEl.textContent = formatMoney(subSalePrice);
        const badge = subOpt && subOpt.querySelector('[part="rc-purchase-option__badge"]');
        const badgeText = 'Save ' + subSalePct + '%';
        if (badge && badge.textContent.trim() !== badgeText) badge.textContent = badgeText;
        // The frequency buttons' "25% Off" (the ongoing plan discount) would
        // contradict the first-order figure, so hide it during the sale. The
        // chosen frequency button is black instead of teal (28 Oct 2026).
        const plans = root.querySelector('rc-selling-plans');
        const plansRoot = plans && plans.shadowRoot;
        if (plansRoot && !plansRoot.querySelector('#mnp-bf-hide-plan-discount')) {
          const st = document.createElement('style');
          st.id = 'mnp-bf-hide-plan-discount';
          st.textContent = '.rc-plans-button__discount { display: none !important; }'
            + ' .rc-plans-button[data-checked] { background: #111 !important; color: #fff !important; }';
          plansRoot.appendChild(st);
        }
      }
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const phrase = '(cancel anytime)';
      let n;
      const hits = [];
      while ((n = walker.nextNode())) {
        if (n.nodeValue.indexOf(phrase) !== -1 && !(n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('mnp-cancel-note'))) hits.push(n);
      }
      // The label sits in a flex row beside the radio icon, so the text and
      // the note share one wrapper span: inside it the note can drop to a
      // new line still aligned with "Subscribe & Save".
      hits.forEach(function (node) {
        const label = document.createElement('span');
        label.className = 'mnp-sub-label';
        label.setAttribute('part', 'mnp-sub-label');
        label.appendChild(document.createTextNode(node.nodeValue.replace(phrase, '').replace(/\s+$/, ' ')));
        const note = document.createElement('span');
        note.className = 'mnp-cancel-note';
        note.setAttribute('part', 'mnp-cancel-note');
        note.textContent = phrase;
        label.appendChild(note);
        node.parentNode.replaceChild(label, node);
      });
      // Subscription "Save N%" during the sale, beside "Subscribe & Save"
      // (before "(cancel anytime)") instead of Recharge's top-right badge,
      // to match the single products (28 Oct 2026).
      const subLabel = subSaleOn && root.querySelector('.rc-purchase-option__subscription .mnp-sub-label');
      if (subLabel && !subLabel.querySelector('.mnp-sub-badge')) {
        const subBadge = document.createElement('span');
        subBadge.className = 'mnp-sub-badge';
        subBadge.textContent = 'Save ' + subSalePct + '%';
        subLabel.insertBefore(subBadge, subLabel.querySelector('.mnp-cancel-note'));
      }
    } catch (e) { /* unexpected widget structure: leave it as Recharge drew it */ }
  }

  let widgetWatched = false;
  function watchWidget() {
    if (widgetWatched) return;
    const host = document.querySelector('recharge-subscription-widget');
    const root = host && host.shadowRoot;
    if (!root || !root.querySelector('.rc-purchase-option')) return;
    widgetWatched = true;
    enhanceWidget(root);
    new MutationObserver(function () { enhanceWidget(root); })
      .observe(root, { childList: true, subtree: true, characterData: true });
  }

  renderValueLine();
  watchWidget();
  // The widget preselects asynchronously and selection clicks happen inside
  // its shadow DOM, so re-render briefly after load and after any click on
  // the widget.
  let tries = 0;
  const warmup = setInterval(function () {
    renderValueLine();
    watchWidget();
    if (++tries > 20) clearInterval(warmup);
  }, 500);
  document.addEventListener('click', function (e) {
    const t = e.target;
    if (t && t.closest && t.closest('recharge-subscription-widget')) {
      setTimeout(renderValueLine, 400);
    }
  }, true);
});




